import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedToken = localStorage.getItem('customerToken');
      const storedUser = localStorage.getItem('customerUser');

      if (storedToken && storedUser && storedUser !== 'undefined') {
        setToken(storedToken);
        try {
          const parsedUser = JSON.parse(storedUser);
          setUser(parsedUser);
        } catch (e) {
          console.error('Error parsing user data:', e);
          localStorage.removeItem('customerToken');
          localStorage.removeItem('customerUser');
        }
      }
    } catch (error) {
      console.error('Error loading auth state:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (phone, countryCode, otp) => {
    const response = await authAPI.verifyOTPAndLogin(phone, countryCode, otp);
    console.log('Login response:', response);
    
    // Handle different response structures
    const newToken = response.data?.token || response.token;
    const customer = response.data?.customer || response.data?.user || response.data;
    
    console.log('Token:', newToken);
    console.log('Customer:', customer);
    
    if (newToken && customer) {
      setToken(newToken);
      setUser(customer);
      localStorage.setItem('customerToken', newToken);
      localStorage.setItem('customerUser', JSON.stringify(customer));
    } else {
      throw new Error('Invalid login response structure');
    }
    
    return response;
  };

  const sendOTP = async (phone, countryCode) => {
    const response = await authAPI.sendOTP(phone, countryCode);
    console.log('OTP sent response:', response);
    return response;
  };

  const updateProfile = async (name, email, profilePic) => {
    const response = await authAPI.updateProfile(name, email, profilePic);
    console.log('Profile update response:', response);
    
    if (response.data) {
      setUser(response.data);
      localStorage.setItem('customerUser', JSON.stringify(response.data));
    }
    
    return response;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('customerToken');
    localStorage.removeItem('customerUser');
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('customerUser', JSON.stringify(userData));
  };

  const isAuthenticated = !!user && !!token;
  
  console.log('Auth State:', { user, token, isAuthenticated });

  const value = {
    user,
    token,
    loading,
    login,
    sendOTP,
    updateProfile,
    logout,
    updateUser,
    isAuthenticated,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
